var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.843,
    height: 205.983,
    viewBox: "0 0 255.843 205.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635",
    transform: "translate(1.881 1.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M0,126.516C35.449,97.664,81.319,85.187,126.32,77.189c30.1-5.351,64.689-7.867,87.7,12.273,10.267,8.988,16.621,25.749,7.59,35.978-3.755,4.252-9.417,6.378-15.029,7.2-20.425,3.006-41.227-10.389-49.862-29.141s-6.216-41.391,3.258-59.734S185.291,11.015,202.752,0",
    transform: "translate(251.414 129.114) rotate(166)",
    fill: "none",
    stroke: "#fcad9a",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531",
    transform: "matrix(-0.695, 0.719, -0.719, -0.695, 50.388, 188.162)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    transform: "translate(0 0)",
    fill: "#2163ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 4,
    cy: 4,
    rx: 4,
    ry: 4,
    transform: "translate(14 0)",
    fill: "#2163ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern5);
export default __webpack_public_path__ + "static/media/pattern5.76b9dbfb.svg";
export { ForwardRef as ReactComponent };